import React, { useState } from "react";
import "./CartContent.css";
import CartBox from "./CartBox/CartBox";
import CartTypeInfo from "../CartTypeInfo/CartTypeInfo";
import { CartType, LimaOrderStatus } from "../../utils/Constants";
import classNames from "classnames";
import SortBoxEndpoints from "../../lib/sortbox/SortBoxEndpoints";

const CartContent = ({
  cartContent,
  getSortBox,
  currentShelf,
  currentBoxID,
  cartType,
  showCancelButton,
  infoBarHeight,
  handleSingleShelf,
}) => {
  var sortCartItems = (x, y) => {
    var packableDiff = (x.packable ? 0 : 1) - (y.packable ? 0 : 1);
    var shelfDiff = x.shelfNumber - y.shelfNumber;
    var sentDiff =
      (x.orderStatus === LimaOrderStatus.Levererad ? 1 : 0) -
      (y.orderStatus === LimaOrderStatus.Levererad ? 1 : 0);
    var boxDiff = x.boxID - y.boxID;

    if (packableDiff !== 0) return packableDiff;
    if (sentDiff !== 0) return sentDiff;
    if (shelfDiff !== 0) return shelfDiff;

    return boxDiff;
  };

  if (!cartContent) return null;

  let classes = classNames({
    "cart-content-header": true,
    flexRow: true,
    spaceBetween: cartType === CartType.MULTI_CART || cartType === CartType.SINGEL_CART,
    spaceAround: cartType === CartType.NORMAL_CART || cartType === CartType.Undefined,
  });

  let containerClasses = classNames({
    "cart-content": true,
    small: cartContent.cartItems && cartContent.cartItems.length > 28 ? true : false,
    "no-cancel-button": !showCancelButton,
  });

  const heightStyle = { height: ` calc(100% - ${infoBarHeight + 20}px)` };
  var cartContentExcludingSingles = cartContent.cartItems.filter(
    (x) => x.shelfNumber !== "51" && x.shelfNumber !== "A"
  );
  var anySingle = cartContent.cartItems.find(
    (x) => !x.isLocked && x.packable && (x.shelfNumber === "51" || x.shelfNumber === "A")
  );
  if (!anySingle)
    anySingle = cartContent.cartItems.find((x) => x.shelfNumber === "51" || x.shelfNumber === "A"); // för att kunna visa ett låst fack om det saknas packbara
  if (anySingle) cartContentExcludingSingles.push(anySingle);
  return (
    <div style={heightStyle} className={containerClasses}>
      <div className={classes}>
        <p>Vagnsinnehåll</p>
        <CartTypeInfo cartType={cartType}></CartTypeInfo>
      </div>
      <div className="cart-content-boxes">
        {cartContentExcludingSingles.sort(sortCartItems).map((x) => {
          return (
            <CartBox
              key={x.boxID}
              box={x}
              currentShelf={currentShelf}
              currentBoxID={currentBoxID}
              getSortBox={getSortBox}
              handleSingleShelf={handleSingleShelf}
            ></CartBox>
          );
        })}
      </div>
    </div>
  );
};

export default CartContent;
